/*
 *
 * UrlTokenizationFields
 *
 * @version 1.0.0
 * @author Davide Polci
 * @since 13-Nov-2025
 */

import UrlTokenizationFields from './UrlTokenizationFields'

export default UrlTokenizationFields
